module.exports = __webpack_public_path__ + "img/scene-logistics.c92cd42b.png";